'use client';

import 'swiper/css';
import 'swiper/css/pagination';

import { Box  } from '@chakra-ui/react';
import type { BoxProps } from '@chakra-ui/react';
import type { JSX, PropsWithChildren } from 'react';
import {	Pagination, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import type { SwiperProps, SwiperSlideProps } from 'swiper/react';

const CustomSwiper = ({ children, ...rest }: PropsWithChildren<SwiperProps>) => {
	return (
		<Swiper
			autoplay={{ delay: 10000 }}
			loop
			modules={[ Pagination, Autoplay ]}
			pagination={true}
			slidesPerView={1}
			{...rest}
		>
			{children}
		</Swiper>
	);
};

export type CarouselRootProps = BoxProps;

const Root = ({ children, ...rest }: PropsWithChildren<CarouselRootProps>) => (
	<Box overflow="hidden" {...rest}>
		{children}
	</Box>
);

export const Carousel = {
	Root:   Root,
	Slide:  SwiperSlide as (props: SwiperSlideProps) => JSX.Element,
	Swiper: CustomSwiper,
};
